import React from 'react';
import { AnimatePresence as AP } from 'framer-motion';
const AnimatePresence = props => {
  return /*#__PURE__*/React.createElement(AP, props);
};
AnimatePresence.displayName = 'AnimatePresence';
export default AnimatePresence;
//# sourceMappingURL=AnimatePresence.js.map